/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
// 资质状态 certificationStatus
export const CERTIFICATION_STATUS = {
  1: { label: '未上传', value: '1' },
  2: { label: '待审核', value: '2' },
  3: { label: '审核通过', value: '3' },
  4: { label: '审核不通过', value: '4' },
  5: { label: '平台审核通过', value: '5' },
  6: { label: '平台审核不通过', value: '6' }
};
// 入驻状态 inStatus
export const IN_STATUS = {
  1: { label: '未入驻', value: '1' },
  2: { label: '已入驻', value: '2' },
  3: { label: '拒绝入驻', value: '3' },
  4: { label: '已退出', value: '4' }
};
// 支付通道状态 payStatus
export const OPEN_STATUS_MAPPING = {
  1: { label: '未开通', value: '1' },
  2: { label: '开通中', value: '2' },
  3: { label: '开通成功', value: '3' },
  4: { label: '开通失败', value: '4' }
};
// 实名认证状态 userAuthStatus
export const USER_AUTH_STATUS = {
  10: { label: '未实名', value: '10' },
  30: { label: '已实名', value: '30' }
  // 40: { label: '认证失败', value: '40' }
};
// 职业认证状态 OccupationAuthStatus
export const OCCUPTION_AUTH_STATUS = {
  1: { label: '未认证', value: '1' },
  2: { label: '已认证', value: '2' }
  // 2: { label: '已认证', value: '2' }
};

// 项目执行状态 projectStatus
export const PROJECT_STATUS = {
  0: { label: '已停用', value: '0' },
  1: { label: '待执行', value: '1' },
  2: { label: '执行中', value: '2' },
  3: { label: '待执行', value: '3' }
};

// 企业签约状态 signStatus
export const SIGN_STATUS = {
  0: { label: '未签约', value: '0' },
  1: { label: '签约中', value: '1' },
  2: { label: '已签署', value: '2' },
  3: { label: '签署失败', value: '3' }
};
